import { Link } from 'react-router-dom'
import { useFranchiseData } from '../hooks/useFranchiseData'
import { BrandLogo } from './BrandMark'
import { getWhatsAppUrl } from '../utils/whatsapp'

const links: { name: string; href: string; external?: boolean }[] = [
  { name: 'Home', href: '/' },
  { name: 'Visa Support', href: '/visa-support' },
  { name: 'Packages', href: '/packages' },
  { name: 'VAIA Flex', href: 'https://vaiaflex.co.za/', external: true },
  { name: 'VAIA Rewards', href: 'https://vaia-rewards.co.za/', external: true },
  { name: 'Contact', href: '/contact' },
]

export default function Footer() {
  const { franchiseData, loading } = useFranchiseData()
  const name = franchiseData?.name || 'VAIA WORLD'
  const whatsappUrl = getWhatsAppUrl(franchiseData)

  if (loading && !franchiseData) {
    return (
      <footer className="border-t border-line px-7 py-9 text-center text-xs text-ink-soft">
        © {name}
      </footer>
    )
  }

  return (
    <footer className="border-t border-line bg-cream">
      <div className="mx-auto max-w-[1180px] px-5 sm:px-7 py-10">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          <div>
            <div className="mb-3">
              <BrandLogo alt={name} className="h-16 w-auto" />
            </div>
            <p className="text-sm text-ink-soft max-w-sm">
              Personal Lifestyle Planners design seamless trips — flights, stays and visa guidance.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm font-semibold text-forest">
            {links.map((item) =>
              item.external ? (
                <a
                  key={item.name}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-vaia-amber-deep"
                >
                  {item.name}
                </a>
              ) : (
                <Link key={item.name} to={item.href} className="hover:text-vaia-amber-deep">
                  {item.name}
                </Link>
              )
            )}
            {whatsappUrl.startsWith('http') && (
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="hover:text-vaia-amber-deep">
                WhatsApp
              </a>
            )}
          </div>
        </div>

        <p className="mt-8 text-center text-xs text-ink-soft">
          © {name}
          {franchiseData?.telephone ? ` · ${franchiseData.telephone}` : ''}
        </p>
      </div>
    </footer>
  )
}
